module.exports = __webpack_public_path__ + "img/promocion-diciembre.69f51504.jpeg";